import { useId, useEffect } from 'react';

import { timeToSeconds } from './util.js';
import useAddYoutubeScript from './useAddYoutubeScript.js';

function YoutubeDefault({
  videoId, autoplay, startTime, youtubeObjectReady,
}) {
  const start = timeToSeconds(startTime);
  const iframeId = useId(); // TODO: REACT 18 only
  const { youtubeMethods } = useAddYoutubeScript({
    videoId,
    start,
    autoplay,
    iframeId,
  });
  // youtubeObjectReady modifies the state of its parent component, so we need a
  // useEffect here
  useEffect(() => {
    if (youtubeObjectReady) {
      youtubeObjectReady(youtubeMethods);
    }
  }, [youtubeMethods, youtubeObjectReady]);

  return (
    <div className="lds-player-wrapper">
      <div className="lds-youtube-video-wrapper">
        <div id={`youtube-video-${iframeId}`} />
      </div>
    </div>
  );
}

export default YoutubeDefault;
